//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    filter: {
      type: Array,
      default: () => {
        return []
      }
    },
    category: {
      type: Object,
      default: () => {
        return {}
      }
    },
    filterPrice: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedFilters: {
      type: Object,
      default: () => {
        return {}
      }
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    FilterItems: () => import('~/components/catalog-new/FilterItems.vue'),
  },

  mounted: function () {
    this.startStickySidebar(0);
  },

  methods: {
    startStickySidebar: function (repeatCount = 0) {
      if (repeatCount >= 10) {
        return;
      }
      if (!window.StickySidebar) {
        setTimeout(() => {
          this.startStickySidebar(repeatCount + 1);
        }, 500);
        return
      }

      const sidebar = new window.StickySidebar("#filter-pc-sidebar", {
        topSpacing: 150,
        bottomSpacing: 20,
        resizeSensor: true,
        innerWrapperSelector: '.sidebar__inner',
        containerSelector: '.catalog-category-page__content-body'
      });
    },

    requestUpdateFilter: function (filters = {}) {
      this.$emit("requestUpdateFilter", filters);
    }
  }
}
